var Pair = /** @class */ (function () {
    function Pair(a, b) {
        this.a = a;
        this.b = b;
    }
    return Pair;
}());
export { Pair };
//# sourceMappingURL=pair.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-dto/main/pair.js
// module id = 987
// module chunks = 14